import Vue from 'vue';

Vue.component('stock-cost-index', () =>
    import(/* webpackChunkName: 'stock-cost-index' */ './stock-cost-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock-cost/index.js